import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { SlotGameType1 } from "../SlotGameType1";

export class JubileeSevenFever extends SlotGameType1 {

	////protected override freegameBonusFactory: FreegameBonusFactory = new JubileeSevenFeverFreegameBonusFactory();
	protected override pickBonusFactory:PickBonusFactory = new JubileeSevenFeverPickBonusFactory();
	//protected panelFactory:IPanelFactory = new JubileeSevenFeverPanelFactory();
	
	protected override helpFactory:IHelpFactory = new JubileeSevenFeverHelpFactory();
	//LED COLOR
	protected override ColorLed:string="217,203,4\n";

	
	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "JubileeSevenFever");

		this.spinnableReelsParams.topBorderWidth = 10;
		this.spinnableReelsParams.bottomBorderWidth = 10;
	}
	


	/*protected SetWindowsView(): void
	{
		let xratio = 1;
		let yratio = 1;
		this.windowRectangle = new PixelRect(188.0 * xratio, 88.0 * yratio, 1545.0 * xratio, 726.0 * yratio);
		this.windowSymbolSize = new Size(5,4);
	}*/

}
/*Freegame*/
// class JubileeSevenFeverFreegameBonus extends FreegameBonus 
// {
// 	public constructor(gameName: string, params: FreegameBonusParams ) {
// 		super(gameName, params);
// 		this.spinnableReelsParams.topBorderWidth = 10;
// 		this.spinnableReelsParams.bottomBorderWidth = 10;
// 	}

// 	public override OnPicked(index: number): void {
// 		//super.OnPicked(index);

// 		if (this.stateMachine.State() == FreegameStates.Pick)
// 		{
// 			// Log.Debug(this.logGroup, "Picked index " + index);

// 			// TODO check state, check index bounds
// 			this.pickedIndex = index;
// 			// protocol.Send("SelectBonusElement",{selectedElement: index});

// 			for (let i = 0; i < this.picks.length; i++) {
// 				if (i == index) {
// 					this.picks[i].BringToFront();
// 					this.picks[i].awardElem.style.fontSize = "150px";
// 					this.picks[i].awardElem.style.left = 100+"px";
// 					this.picks[i].awardElem.style.top = 140+"px";
					
				
// 				}
// 				else {
// 					this.picks[i].PushToBack();
// 					this.picks[i].awardElem.style.fontSize = "70px";
// 					//this.picks[i].BringToFront();
// 					//this.picks[i].awardElem.style.fontSize = "80px";
// 					//this.picks[i].awardElem.style.left = 100+"px";
// 					//this.picks[i].awardElem.style.top = 150+"px";
// 				}
// 			}

// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
// 		}
// 	}



	

// 	// set new pick positions
// 	protected override PicksPositions(): FreegamePickElemGeometry[] {
// 		let geometry: FreegamePickElemGeometry[] = [];

// 		let displayWidth: number = 458;
// 		let displayHeight: number = 513;
// 		let displayRects: PixelRect[] = 
// 		[
// 			new PixelRect(50, 328, displayWidth, displayHeight),
// 			new PixelRect(363, 528, displayWidth, displayHeight),
// 			new PixelRect(705, 328, displayWidth, displayHeight),
// 			new PixelRect(1044, 528, displayWidth, displayHeight),
// 			new PixelRect(1386, 328, displayWidth, displayHeight),
// 		];

// 		// offset relative to pick rect
// 		let pickRect = new PixelRect(70, 139, 282, 246);
// 		let awardRect = new PixelRect(140, 150, 260, 280);//let awardRect = new PixelRect(150, 90, 260, 280);

// 		for (let i = 0; i < displayRects.length; i++) {
// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect));
// 		}

// 		return geometry;
// 	}



	

// 	protected override PrepareFonts(resourceManager: ResourceManager): void 
// 	{
// 		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
// 		resourceManager.Add(new FontResource(this.params.gameResourcesBasePath + "WildNature.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
// 	}

// 	// protected PrepareMessage(resourceManager: ResourceManager)
// 	// {
// 	// 	super.PrepareMessage(resourceManager);

// 	// 	SetStyles(this.view.querySelectorAll(".dialog"), { 
// 	// 		width: "850px",
// 	// 		height: "850px",
// 	// 		textShadow: "5px 8px black",
// 	// 		color: "#FFFFFF",
			
// 	// 	});

// 	// 	SetStyles(this.view.querySelectorAll("#startfree3"), { fontSize:"35px",textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",});
// 	// 	SetStyles(this.view.querySelectorAll("#contents3"), { fontSize:"60px", width:"110%", left: "-40px",textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
// 	// 	SetStyles(this.view.querySelectorAll(".header"), { fontSize:"130px",textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
// 	// 	SetStyles(this.view.querySelectorAll(".bonusName"), { fontSize:"100px", lineHeight: "100px",textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
// 	// 	SetStyles(this.view.querySelectorAll(".numPickedFreegames"), { fontSize:"150px",textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
// 	// 	SetStyles(this.view.querySelectorAll("#startfree2"), { fontSize:"40px",textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
// 	// 	SetStyles(this.view.querySelectorAll("#contents1"), { fontSize:"84px", lineHeight: "150px",textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
// 	// 	SetStyles(this.view.querySelectorAll("#startfree1"), { fontSize:"80px", lineHeight: "150px" ,position: "relative",
// 	// 	top: "30px",textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
// 	// });
// 	// 	SetStyles(this.view.querySelectorAll("#startfree2"), { fontSize:"70px", lineHeight: "70px",textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
// 	// 	SetStyles(this.view.querySelectorAll("#startfree3"), { fontSize:"60px", lineHeight: "60px", textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
// 	// 	SetStyles(this.view.querySelectorAll("#contents2"), { fontSize:"130px", lineHeight: "120px", textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
		
// 	// 	SetStyles(this.view.querySelectorAll("#headerend"), { fontSize:"100px" ,textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
// 	// 	SetStyles(this.view.querySelectorAll("#startend1"), { fontSize: "100px", lineHeight: "140px", position: "relative", top: "10px", textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",});
// 	// 	SetStyles(this.view.querySelectorAll(".totalWin"), { fontSize:"140px" ,textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px", });
// 	// 	SetStyles(this.view.querySelectorAll("#startend2"), { fontSize:"70px", textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",});
// 	// 	SetStyles(this.view.querySelectorAll("#startend3"), { fontSize:"60px" ,lineHeight:"50px", width: "130%",left: "-123px",textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",});

// 	// 	// pick instructions on pick screen
// 	// 	SetStyles(this.view.querySelector(".pickInstructions .pick1"), {lineHeight: "100px", color: "#FFFFFF", textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",});
// 	// 	SetStyles(this.view.querySelectorAll(".startbut"),{
// 	// 		textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px"
// 	// 	});
		
// 	// }
// }
// /*Finish Freegame*/



// class JubileeSevenFeverFreegamePickElement extends FreegamePickElement
// {
// 	public override AwardElemePrepare()
// 	{
// 		super.AwardElemePrepare();
// 		this.awardElem.style.left = 100+"px";
// 		this.awardElem.style.top =  150+"px";
// 		this.awardElem.style.fontSize ="70px";
// 	}
// }


// class JubileeSevenFeverFreegameBonusFactory extends FreegameBonusFactory
// {
// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus 
// 	{
// 		return new JubileeSevenFeverFreegameBonus(gameName, params);
// 	}
// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
// 	{
// 		return new JubileeSevenFeverFreegamePickElement(params);
// 	}

// }

//Panel Colorized
class JubileeSevenFeverPanelFactory implements IPanelFactory
{
	public CreateNewPanel(params: PanelParams):Panel
	{
		return new JubileeSevenFeverPanel(params);
	}
}

class JubileeSevenFeverPanel extends Panel
{
	protected override ButtonBackground():ButtonColors
	{
		let color:ButtonColors ={
			backgroundButtonColor: "linear-gradient(rgb(30, 3, 41),rgb(102, 11, 140), rgb(159, 15, 255),rgb(102, 11, 140),rgb(30, 3, 41)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor:"linear-gradient(to left , transparent, rgb(255, 69, 230),transparent ) 0 10 100%",
		};
		return color;
		
	}

}

	//Help Colorized
	class JubileeSevenFeverHelpFactory implements IHelpFactory
	{
		public CreateNewHelp(params: HelpParameters):Help
		{
			return new   JubileeSevenFeverHelp(params);
		}
	}

	class JubileeSevenFeverHelp extends Help
	{
		protected override BackgroundPanel():HelpPanelColor
		{
			let color:HelpPanelColor = {
				backgroundPanelColor: "linear-gradient(rgb(30, 3, 41),rgb(102, 11, 140), rgb(159, 15, 255),rgb(102, 11, 140),rgb(30, 3, 41)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};

			return color;
		}
	}


/**
 * PICK BONUS 
 */
class JubileeSevenFeverPickBonus extends PickBonus
{

}

class JubileeSevenFeverPickBonusElement extends PickBonusElement
{
}

class JubileeSevenFeverPickBonusFactory extends PickBonusFactory
{
	public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus 
	{
		return new JubileeSevenFeverPickBonus(gameName, params);
	}

	public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement
	{
		return new JubileeSevenFeverPickBonusElement(params);
	}
	
}
